// Blackout Scripts — client behavior

// Tier picker: highlight selected radio in PDP
document.addEventListener('change', function(e){
  if (e.target.name === 'id' && e.target.closest('.pdp-tiers')){
    document.querySelectorAll('.pdp-tiers .tier').forEach(function(t){ t.classList.remove('active'); });
    e.target.closest('.tier').classList.add('active');
  }
});

// Update cart count after add-to-cart (theme-soft fetch)
document.addEventListener('submit', function(e){
  var form = e.target;
  if (form.matches('form[action="/cart/add"]')){
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){
        var c = document.getElementById('cart-count');
        if (c) c.textContent = cart.item_count;
        window.location.href = '/cart';
      })
      .catch(function(){ form.submit(); });
  }
});

// ── v2 polish ────────────────────────────────────────────────────────────────
var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Mobile menu (burger toggle)
(function(){
  var burger = document.getElementById('nav-burger');
  var menu = document.getElementById('mobile-menu');
  if (!burger || !menu) return;
  burger.addEventListener('click', function(){
    var open = menu.classList.toggle('open');
    burger.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('menu-open', open);
  });
  // close on link tap
  menu.addEventListener('click', function(e){
    if (e.target.closest('a')){
      menu.classList.remove('open'); burger.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    }
  });
})();

// Nav: elevate after scrolling
(function(){
  var nav = document.querySelector('.nav');
  if (!nav) return;
  var on = false;
  function check(){
    var s = window.scrollY > 8;
    if (s !== on){ on = s; nav.classList.toggle('scrolled', s); }
  }
  window.addEventListener('scroll', check, { passive: true });
  check();
})();

// Scroll-reveal: cards float in as they enter the viewport
(function(){
  var els = document.querySelectorAll('.feature, .product, .review, .help-card, .rs-stat, .faq-item, .status-row, .cta-card, .sec-head');
  if (!els.length) return;
  if (REDUCED || !('IntersectionObserver' in window)){
    els.forEach(function(el){ el.classList.add('rv', 'in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
  els.forEach(function(el, i){
    el.classList.add('rv');
    el.style.transitionDelay = ((i % 6) * 55) + 'ms';   // stagger within a row
    io.observe(el);
  });
})();

// Card spotlight: highlight follows the cursor
document.addEventListener('pointermove', function(e){
  var t = e.target.closest && e.target.closest('.feature, .product, .review, .help-card');
  if (!t) return;
  var r = t.getBoundingClientRect();
  t.style.setProperty('--mx', (e.clientX - r.left) + 'px');
  t.style.setProperty('--my', (e.clientY - r.top) + 'px');
}, { passive: true });

// Stat counters: count up when visible (e.g. "43,000+", "4.9", "24/7" is skipped)
(function(){
  var nums = document.querySelectorAll('.rs-num, .cta-stat-num');
  if (!nums.length || REDUCED || !('IntersectionObserver' in window)) return;
  function animate(el){
    var raw = el.textContent.trim();
    var m = raw.match(/^([\d,]+(?:\.\d+)?)([^\d]*)$/);   // number + suffix only
    if (!m) return;                                       // "24/7" etc: leave alone
    var target = parseFloat(m[1].replace(/,/g, ''));
    var suffix = m[2] || '';
    var decimals = (m[1].split('.')[1] || '').length;
    var hasCommas = m[1].indexOf(',') !== -1;
    var t0 = null;
    function fmt(v){
      var s = v.toFixed(decimals);
      if (hasCommas) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return s + suffix;
    }
    function step(ts){
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / 1100, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = raw;                          // exact original at the end
    }
    requestAnimationFrame(step);
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting){ animate(en.target); io.unobserve(en.target); }
    });
  }, { threshold: 0.5 });
  nums.forEach(function(el){ io.observe(el); });
})();

// Trust marquee: duplicate the pill row until it can loop seamlessly
(function(){
  var track = document.querySelector('.trust-track');
  if (!track || REDUCED) return;
  var base = track.querySelector('.trust-games');
  if (!base || !base.children.length) return;
  // need enough width to cover the viewport twice, and an EVEN copy count —
  // the CSS loops with translateX(-50%), which is only seamless when the
  // track is two identical halves.
  var copies = 1;
  while ((track.scrollWidth < (track.parentElement.offsetWidth * 2 + 80)) && copies < 8){
    var clone = base.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
    copies++;
  }
  if (copies % 2){
    var extra = base.cloneNode(true);
    extra.setAttribute('aria-hidden', 'true');
    track.appendChild(extra);
  }
})();
